module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part"
  }, [_c('h2', {
    staticClass: "h2p"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("Part One")]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('em', [_vm._v("The mountain she saw before her that measured"), _c('br'), _vm._v(" the distance she had to climb to gain her daddy’s favor"), _c('br'), _vm._v(" back from being; ‘nothing but an idiot’,"), _c('br'), _vm._v(" was too high for such a little girl"), _c('br'), _vm._v(" who only wanted to hear the words;"), _c('br'), _vm._v(" “Kieran, I love you and I’m proud of you.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2b3892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 81
// module chunks = 0